import { Dayjs } from 'dayjs';

/**
 * The assistant portal historically stored queue documents under YYYY-M-D,
 * while the doctor dashboard uses YYYY-MM-DD. Read both paths until every
 * producer has migrated to the canonical padded form.
 */
export const waitingListDateKeys = (date: Dayjs): string[] =>
  Array.from(new Set([date.format('YYYY-MM-DD'), date.format('YYYY-M-D')]));

// The assistant portal currently reads this legacy path for its live queue.
// New dashboard writes must use the same path until both clients migrate
// together. API payloads can continue to use the padded ISO date.
export const assistantWaitingListDateKey = (date: Dayjs): string => date.format('YYYY-M-D');
